import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import 'whatwg-fetch';

export default class AppStore extends Vuex.Store {
  constructor(debug) {
    Vue.use(Vuex);
    super({
      strict: debug,
      plugins: debug ? [createLogger()] : [],
      state: {
        data: {
          isSmartphone: false,
          isMobileapp: false,
          isPremium: false,
        },
        loginIsShow: false,
      },
      mutations: {
        initData(state, dataSet) {
          state.data.isSmartphone = dataSet.issmartphone ? JSON.parse(dataSet.issmartphone) : false;
          state.data.isMobileapp = dataSet.ismobileapp ? JSON.parse(dataSet.ismobileapp) : false;
          state.data.isPremium = dataSet.userpremium ? JSON.parse(dataSet.userpremium) : false;
        },
        setData(state, dataSet) {
        },
        setLoginIsShow(state, loginIsShow) {
          state.loginIsShow = loginIsShow;
        },
      },
      actions: {
        initData({commit}, dataSet) {
          if (!dataSet) {
            dataSet = {};
          }
          commit('initData', dataSet);
        },
        setData({commit}, dataSet) {
          if (!dataSet) {
            dataSet = {};
          }
          commit('setData', dataSet);
        },
        setLoginIsShow({commit}, loginIsShow) {
          commit('setLoginIsShow', loginIsShow);
        },
      }
    });
  }
}
